var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{style:({ transform: `scale(${_vm.scale}) rotate(${_vm.rotation}deg)` }),attrs:{"src":require("@/assets\\images\\busImage\\arrow_left.png")},on:{"mousewheel":_vm.onWheel,"mousedown":_vm.onMouseDown,"touchstart":_vm.onTouchStart,"touchmove":_vm.onTouchMove}})])
}
var staticRenderFns = []

export { render, staticRenderFns }